var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFileError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-File_Error"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "File_Error",
    "data-name": "File Error",
    clipPath: "url(#clip-File_Error)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36033",
    "data-name": "Group 36033",
    transform: "translate(-9448.25 -14169.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17440",
    "data-name": "Rectangle 17440",
    width: 10.429,
    height: 10.429,
    rx: 4,
    transform: "translate(9449 14170)",
    fill: "rgba(237,125,49,0.15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_17440_-_Outline",
    "data-name": "Rectangle 17440 - Outline",
    d: "M2.625.656A1.971,1.971,0,0,0,.656,2.625v5.25A1.971,1.971,0,0,0,2.625,9.844h5.25A1.971,1.971,0,0,0,9.844,7.875V2.625A1.971,1.971,0,0,0,7.875.656H2.625m0-.656h5.25A2.625,2.625,0,0,1,10.5,2.625v5.25A2.625,2.625,0,0,1,7.875,10.5H2.625A2.625,2.625,0,0,1,0,7.875V2.625A2.625,2.625,0,0,1,2.625,0Z",
    transform: "translate(9449 14170)",
    fill: "#ed7d31"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_36035",
    "data-name": "Group 36035",
    transform: "translate(9453.855 14172.625)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36034",
    "data-name": "Group 36034",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36033-2",
    "data-name": "Group 36033"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_4992",
    "data-name": "Line 4992",
    d: "M-.206,3.469A.394.394,0,0,1-.6,3.075V-.206A.394.394,0,0,1-.206-.6a.394.394,0,0,1,.394.394V3.075A.394.394,0,0,1-.206,3.469Z",
    transform: "translate(0.6 0.6)",
    fill: "#ed7d31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_4993",
    "data-name": "Line 4993",
    transform: "translate(0.394 5.316)",
    fill: "#ed7d31"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1847",
    "data-name": "Ellipse 1847",
    cx: 0.394,
    cy: 0.394,
    r: 0.394,
    transform: "translate(0 4.922)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_1847_-_Outline",
    "data-name": "Ellipse 1847 - Outline",
    d: "M.394,0A.394.394,0,1,1,0,.394.394.394,0,0,1,.394,0Z",
    transform: "translate(0 4.922)",
    fill: "#ed7d31"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileError);
export default __webpack_public_path__ + "static/media/Icon_FileError.efc84d690735943cb1065633d38d9caa.svg";
export { ForwardRef as ReactComponent };